export const productsRate = {
  error: {
    code: 'S001',
    userMessage: 'Data Found'
  },
  hasError: false,
  packageSelection: [
    {
      criteriaAdjustment: {
        annualMileages: [15000, 20000, 25000],
        deposits: [0, 4000],
        durations: [24, 36, 48]
      },
      error: {
        code: 'S001',
        userMessage: 'Data Found'
      },
      hasError: false,
      result: {
        globalText: {
          legalMention: [
            {
              text: '{modelText}, senza opzioni al prezzo del costruttore del 04/12/2023 in LLD per 36 mesi / 45000 km massimi, ovvero 36 [b] canoni [/b] mensili di 450 € IVA inclusa dopo un anticipo di 4000.0 € IVA inclusa, comprensivo dei servizi di garanzia*, manutenzione*, assistenza* e gestione.[url=http://www.example.com]visit this link![/url]'
            }
          ]
        },
        quotationID: 'itplqwo5mo1715075165037',
        services: [
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'ROAD TAX customer',
            rental: {
              amountExclTax: 0,
              amountInclTax: 0
            },
            servMand: '',
            serviceCode: '1701002953'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'Ghost',
            rental: {
              amountExclTax: 4.43,
              amountInclTax: 3.63
            },
            servMand: '',
            serviceCode: '1701002548'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'I/F penale 10% I-Care',
            rental: {
              amountExclTax: 11.72,
              amountInclTax: 9.61
            },
            servMand: '',
            serviceCode: '1701001453'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'RIPARAZIONE DANNI penale 500€ I-Care',
            rental: {
              amountExclTax: 49.08,
              amountInclTax: 40.23
            },
            servMand: '',
            serviceCode: '1701001448'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'RCA max 25 mil penale 250€ I-Care',
            rental: {
              amountExclTax: 59.32,
              amountInclTax: 48.62
            },
            servMand: '',
            serviceCode: '1701001443'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'Leasys I-Care Smart',
            rental: {
              amountExclTax: 8.26,
              amountInclTax: 6.77
            },
            servMand: '',
            serviceCode: '1701001437'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'FINES Re-notification std to the client',
            rental: {
              amountExclTax: 0,
              amountInclTax: 0
            },
            servMand: '',
            serviceCode: '1701001207'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'TOWING LT',
            rental: {
              amountExclTax: 3.09,
              amountInclTax: 2.53
            },
            servMand: '',
            serviceCode: '1701001123'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'MODE OF PAYMENT',
            rental: {
              amountExclTax: 0.21,
              amountInclTax: 0.17
            },
            servMand: '',
            serviceCode: '1701000947'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'MAINTENANCE full (ordinary and extra)',
            rental: {
              amountExclTax: 21.14,
              amountInclTax: 17.33
            },
            servMand: '',
            serviceCode: '1701000942'
          },
          {
            informations: [
              {
                text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
              }
            ],
            label: 'BILLING mail',
            rental: {
              amountExclTax: 0,
              amountInclTax: 0
            },
            servMand: '',
            serviceCode: '1701000917'
          }
        ],
        teaser: {
          data: {
            customer: {
              address: '',
              birthDate: '',
              birthPlace: '',
              city: '',
              contactpersonemail: '',
              contactpersonlastname: '',
              contactpersonname: '',
              contactpersonphone: '',
              country: '',
              email: '',
              houseNumber: '',
              name: '',
              phone: '',
              regionCode: '',
              sex: '',
              vatNumber: ''
            },
            deposit: 4000,
            duration: 36,
            financialProductLabel: ' SOL B2B',
            globalMileage: 45000,
            productKey: '1000015669'
          },
          regularPayment: {
            amountExclTax: 1179.49,
            amountInclTax: 1438.98,
            financialInst: 1050.6,
            financialInstVat: 1281.73,
            mandServInst: 128.89,
            mandServInstVat: 157.25,
            optServInst: 0,
            optServInstVat: 0
          }
        }
      },
      uuid: 'uuid1'
    }
  ]
};

export const customRate = {
  error: {
    code: 'S001',
    userMessage: 'Data Found'
  },
  hasError: false,
  result: {
    globalText: {
      legalMention: [
        {
          text: '{modelText}, senza opzioni al prezzo del costruttore del 04/12/2023 in LLD per 36 mesi / 45000 km massimi, ovvero 36 [b] canoni [/b] mensili di 450 € IVA inclusa dopo un anticipo di 4000.0 € IVA inclusa, comprensivo dei servizi di garanzia*, manutenzione*, assistenza* e gestione.[url=http://www.example.com]visit this link![/url]'
        }
      ]
    },
    quotationID: 'itplqwo5mo1715075165037',
    services: [
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'ROAD TAX customer',
        rental: {
          amountExclTax: 0,
          amountInclTax: 0
        },
        servMand: '',
        serviceCode: '1701002953'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'Ghost',
        rental: {
          amountExclTax: 4.43,
          amountInclTax: 3.63
        },
        servMand: '',
        serviceCode: '1701002548'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'I/F penale 10% I-Care',
        rental: {
          amountExclTax: 11.72,
          amountInclTax: 9.61
        },
        servMand: '',
        serviceCode: '1701001453'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'RIPARAZIONE DANNI penale 500€ I-Care',
        rental: {
          amountExclTax: 49.08,
          amountInclTax: 40.23
        },
        servMand: '',
        serviceCode: '1701001448'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'RCA max 25 mil penale 250€ I-Care',
        rental: {
          amountExclTax: 59.32,
          amountInclTax: 48.62
        },
        servMand: '',
        serviceCode: '1701001443'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'Leasys I-Care Smart',
        rental: {
          amountExclTax: 8.26,
          amountInclTax: 6.77
        },
        servMand: '',
        serviceCode: '1701001437'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'FINES Re-notification std to the client',
        rental: {
          amountExclTax: 0,
          amountInclTax: 0
        },
        servMand: '',
        serviceCode: '1701001207'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'TOWING LT',
        rental: {
          amountExclTax: 3.09,
          amountInclTax: 2.53
        },
        servMand: '',
        serviceCode: '1701001123'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'MODE OF PAYMENT',
        rental: {
          amountExclTax: 0.21,
          amountInclTax: 0.17
        },
        servMand: '',
        serviceCode: '1701000947'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'MAINTENANCE full (ordinary and extra)',
        rental: {
          amountExclTax: 21.14,
          amountInclTax: 17.33
        },
        servMand: '',
        serviceCode: '1701000942'
      },
      {
        informations: [
          {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
          }
        ],
        label: 'BILLING mail',
        rental: {
          amountExclTax: 0,
          amountInclTax: 0
        },
        servMand: '',
        serviceCode: '1701000917'
      }
    ],
    teaser: {
      data: {
        customer: {
          address: '',
          birthDate: '',
          birthPlace: '',
          city: '',
          contactpersonemail: '',
          contactpersonlastname: '',
          contactpersonname: '',
          contactpersonphone: '',
          country: '',
          email: '',
          houseNumber: '',
          name: '',
          phone: '',
          regionCode: '',
          sex: '',
          vatNumber: ''
        },
        deposit: 4000,
        duration: 36,
        financialProductLabel: ' SOL B2B',
        globalMileage: 45000,
        productKey: '1000015669'
      },
      regularPayment: {
        amountExclTax: 1179.49,
        amountInclTax: 1438.98,
        discountCode: 'TESTPROMO',
        financialInst: 1050.6,
        financialInstVat: 1281.73,
        mandServInst: 128.89,
        mandServInstVat: 157.25,
        optServInst: 0,
        optServInstVat: 0
      }
    }
  },
  uuid: '72aee987-6a65-4006-9328-08c6e94bf004'
};
